import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { UserService } from "src/app/shared/user.service";
import { ContractTypeService } from "../../../shared/contract-type.service";

@Component({
  selector: "app-contract-type-list",
  templateUrl: "./contract-type-list.component.html",
  styleUrls: ["./contract-type-list.component.css"],
})
export class ContractTypeListComponent implements AfterViewInit {
  // Table columns
  displayedColumns: string[] = ["Contract Type", "Created By", "Last Updated", "Version No", "Status", "Action"];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataLoading = false;
  constructor(public userService: UserService, public service: ContractTypeService) {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.dataLoading = true;
    this.getContractType();
  }

  async getContractType() {
    await this.service.getContractList(true).then((allContractType: any) => {
      allContractType.forEach((contract: any) => {
        contract.updatedDate = moment(contract.updatedDate).format("lll");
      });
      this.dataSource.data = allContractType;
    });

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = "Last Updated";
      this.dataSource.sort.direction = "desc";
      this.customSortData({
        active: "Last Updated",
        direction: "desc",
      } as Sort);
    }
    this.dataLoading = false;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === "") {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || "").toString().toLowerCase();
      const valueB = (b[event.active] || "").toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === "asc");
    });

    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
